<template>
    <v-container>
        <v-card slot="rightContainer" outlined>
            <v-card-title class="grey lighten-4">
                <b>HISTORICO ORDENES DE PRODUCCION</b>
                <v-spacer />
                <v-col cols="12" ></v-col>
                <v-col cols="12" sm="3">
                    <v-menu ref="menu" v-model="menu3" :close-on-content-click="false" transition="scale-transition"
                        offset-y max-width="290px" min-width="auto">
                        <template #activator="{ on, attrs }">
                            <v-text-field v-model="fechaFiltro" hide-details="auto" dense label="FILTRAR POR RANGO - MES"
                                prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" />
                        </template>
                        <v-date-picker v-model="fechaFiltro" range no-title scrollable>
                            <v-spacer />
                            <v-btn text color="primary" @click="menu3 = false"> CERRAR </v-btn>
                            <v-btn color="primary" :loading="loadingLista" @click="getLista"> BUSCAR </v-btn>
                        </v-date-picker>
                    </v-menu>
                </v-col>
                <v-col cols="12" sm="3">
                    <v-text-field dense v-model="search" append-icon="mdi-magnify" label="BUSCAR" single-line
                        hide-details />
                </v-col>
                <v-col cols="12" sm="3">

                                <v-select
                  v-model="statusFiltro"
                  :items="[
                    { text: 'Todas', value: '' },
                    { text: 'Abiertas', value: 1 },
                    { text: 'Cerradas', value: 0 }
                  ]"
                  label="Filtrar por Estado"
                  dense
                  hide-details
                />
              </v-col>
              <v-col cols="12" sm="6" md="2" >
                <v-btn @click="downloadXlsxFiltrado" :loading="loading" color="success">
                  DESCARGAR FILTRADO
                </v-btn>
              </v-col>
            </v-card-title>
            <v-card-text>
                <v-row dense>
                    <v-col cols="12">
                        <v-data-table multi-sort :search="search" :items="_listainventario" :headers="headers"
                            class="elevation-1" :items-per-page="20">
                            <template v-slot:[`item.action`]="{ item }">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon v-bind="attrs" v-on="on" color="orange lighten-2" small
                                            @click="calltoprint(item)">mdi-factory</v-icon>
                                    </template>
                                    <span>Descargar</span>

                                </v-tooltip>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon v-bind="attrs" v-on="on" color="red" small
                                            @click="closePosition(item)">mdi-clock-in</v-icon>
                                    </template>
                                    <span>Cerrar Orden</span>
                                </v-tooltip>
                            </template>
                            <template v-slot:[`item.status`]="{ item }">
                              <v-chip dark :color="item.status === 1 ? 'green' : 'red'" class="white--text font-weight-bold" small>
                                    {{ item.status == 1 ? 'ACTIVE' : 'CERRADA' }}
                                </v-chip>
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </v-container>
</template>
<script>
import { mapGetters, mapState, mapActions } from 'vuex'
import { format, subDays, addDays } from 'date-fns'
import { sortItems } from '@/utils/genericUtils'
import request from '@/utils/request'
const { formatInTimeZone } = require('date-fns-tz')
import { exportXLSX } from '@/utils'

function parseProductoDescripcion(desc) {
    let color = null
    let medida = null
    if (!desc) return { color, medida }

    const medidaMatch = desc.match(/Medida\s*:\s*\(?\[?([^\]\)]+)\]?\)?/i)
    if (medidaMatch) medida = medidaMatch[1].trim()

    const colorMatch = desc.match(/Color\s*:\s*(.+?)(?:\s+(?:Forma|Medida|Sistema|Material|Marca|\|)\s*:|\s*$)/i)
    if (colorMatch) color = colorMatch[1].trim()

    return { color, medida }
}

export default {
    data() {
        return {
            fechaFiltro: [format(subDays(new Date(), 31), 'yyyy-MM-dd'), format(addDays(new Date(), 1), 'yyyy-MM-dd')],
            menu3: false,
            loadingLista: false,
            loading:false,
            statusFiltro: '',

            search: '',
            headers: [
                { text: '', value: 'action', sortable: false },
                { text: 'ID', value: 'id' },
                { text: 'status', value: 'status' },

                { text: 'fechaEmision', value: 'fechaEmision' },
                { text: 'fechaCierre', value: 'fechaCierre' },
                { text: 'fechaEntregaVenta', value: 'fechaEntregaVenta' },
                { text: 'vendedor', value: 'vendedor' },
                { text: 'personalCargo', value: 'personalCargo' },

                { text: 'ordenPedido', value: 'ordenPedido' },
                { text: 'producto', value: 'producto' },
                { text: 'color', value: 'color' },
                { text: 'medida', value: 'medida' },

                { text: 'material', value: 'material' },
                { text: 'observaciones', value: 'observaciones' }
            ]
        }
    },
    computed: {
        ...mapGetters('inventario', ['ordenProduccion']),
        ...mapState('ventas', ['datos']),
        _listainventario() {
          let newLista = []
          if (this.ordenProduccion.length > 0) {
            this.ordenProduccion.forEach((x) => {
              newLista.push({
                ...x,
                fechaCierre: !x.status ? formatInTimeZone(x.updated_at, 'UTC', "yyyy-MM-dd HH:mm") : ''
              })
            })
          }

          if (this.statusFiltro !== '') {
            newLista = newLista.filter(item => item.status === this.statusFiltro)
          }

          return sortItems(newLista, 'id', 1)
        }

    },
    methods: {
        async getLista() {
            this.loadingLista = true
            await this.$store.dispatch('inventario/getListaOrdenProduccion', { fechaFiltro: this.fechaFiltro })
            this.loadingLista = false
            this.menu3 = false
        },
        async calltoprint(item) {
            console.log('itemAQUIIII--------------------', item)
            // Fallback: parsear color/medida de la descripción si están vacíos (órdenes viejas)
            const parsed = parseProductoDescripcion(item.producto)
            // Priorizar parseo sobre DB (DB tiene "NO DEFINIDO" como string truthy)
            const colorFinal = parsed.color || item.color || 'NO DEFINIDO'
            const medidaFinal = parsed.medida || item.medida || 'NO DEFINIDO'

            // Obtener image_url de la venta asociada
            let image_url = null
            if (item.ordenPedido) {
                try {
                    const venta = await this.$store.dispatch('ventas/ventaProducto', { id: item.ordenPedido })
                    if (venta && venta.productos) {
                        const productos = typeof venta.productos === 'string' ? JSON.parse(venta.productos) : venta.productos
                        const prodMatch = productos.find(p => p.image_url)
                        image_url = prodMatch?.image_url || null
                    }
                } catch (e) {
                    console.warn('No se pudo obtener image_url de la venta:', e.message)
                }
            }

            await this.$store.dispatch('reporte/reporteOrdenProduccion', {
                id: item.id,
                annio: item.fechaEmision.split('-')[0],
                vendedora: item.vendedor,
                fechaEmision: item.fechaEmision,
                ordenPedido: item.ordenPedido,
                personalCargo: item.personalCargo,
                producto: item.producto,
                color: colorFinal,
                medida: medidaFinal,
                material: item.material,
                observacion: item.observaciones,
                cantidad: item.cantidad || 1,
                image_url
            })
        },
        async closePosition(item) {
            console.log('itemAQUIIII--------------------', item)
            await this.$store.dispatch('inventario/closeOrdenProduccion', {
                data: {
                    status: !item.status
                },
                id: item.id
            })
            // Si se cierra la orden (status pasa a 0/false), auto-fill PROCESO INTERNO en la venta
            if (item.status === 1 && item.ordenPedido) {
                const today = formatInTimeZone(new Date(), 'America/Lima', 'yyyy-MM-dd')
                try {
                    // El PATCH de LoopBack reemplaza el objeto JSON completo de atributos,
                    // así que primero leemos los actuales y mergeamos encima. Si el GET o el
                    // parse fallan, no se envía el PATCH (mejor no actualizar que borrar datos).
                    const { data: venta } = await request({
                        url: `/api-loopback/tm_ventas/${item.ordenPedido}`,
                        method: 'GET'
                    })
                    const attrs = venta && venta.atributos
                    const atributosActuales = typeof attrs === 'string' ? JSON.parse(attrs || '{}') : (attrs || {})
                    await this.$store.dispatch('ventas/patchVenta', {
                        id: item.ordenPedido,
                        atributos: {
                            ...atributosActuales,
                            fechaFabricacion: today,
                            encargadoFabricacion: item.personalCargo
                        }
                    })
                } catch (e) {
                    console.error('Error al actualizar PROCESO INTERNO:', e)
                }
            }
            await this.getLista()
        },
        async downloadXlsxFiltrado() {
  this.loading = true

  const headers = [
    'id',
    'status',
    'fechaEmision',
    'fechaCierre',
    'fechaEntregaVenta',
    'vendedor',
    'personalCargo',
    'ordenPedido',
    'producto',
    'color',
    'medida',
    'material',
    'observaciones'
  ]

  const items = this._listainventario.map(item => ({
    ...item
  }))

  const filename = `Ordenes_${this.statusFiltro === '' ? 'todas' : this.statusFiltro === 1 ? 'abiertas' : 'cerradas'}_${new Date().toISOString()}`

  exportXLSX({
    headers: [
      'ID',
      'Estado',
      'Fecha Emisión',
      'Fecha Cierre',
      'Fecha Entrega Venta',
      'Vendedor',
      'Responsable',
      'Orden Pedido',
      'Producto',
      'Color',
      'Medida',
      'Material',
      'Observaciones'
    ],
    campos: headers,
    arrayData: items
  }, { filename })

  this.loading = false
}

    },
    async mounted() {
        await this.getLista()
    }
}
</script>
